<!--
 * @Author: 仙道
 * @Date: 2022-07-02 23:35:07
 * @LastEditTime: 2022-08-27 20:34:29
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/modules/TaskDeviceModal.vue
-->
<template>
  <!-- <a-modal
    :body-style="{
      height: '600px',
      overflow: 'hidden',
      overflowY: 'scroll',
    }"
    :title="title"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    v-model="visible"
  >-->
  <a-drawer
    :body-style="{ paddingBottom: '70px',overflowY:'scroll' }"
    :closable="false"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <!-- <template slot="footer"> -->
    <!-- <a-button @click="handleOk(1)" type="primary" v-if="!disableSubmit">保存记录</a-button>
    <a-button @click="handleOk(2)" type="primary" v-if="!disableSubmit">结束保养</a-button>
    <a-button @click="handlePrint" type="primary" v-if="disableSubmit">打印</a-button>

    <a-button @click="handleCancel">关闭</a-button>-->
    <!-- </template> -->

    <task-form :canEdit="canEdit" @ok="submitCallback" ref="realForm" v-if="!disableSubmit"></task-form>
    <task-device-detail ref="realForm" v-else />
    <div
      :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'center',
          zIndex: 1,
        }"
    >
      <a-button :style="{ marginLeft: '5px' }" @click="handleOk(1)" type="primary" v-if="!disableSubmit">保存记录</a-button>
      <a-button :style="{ marginLeft: '5px' }" @click="handleOk(2)" type="primary" v-if="!disableSubmit">结束保养</a-button>
      <a-button :style="{ marginLeft: '5px' }" @click="handlePrint" key type="primary" v-if="disableSubmit">打印</a-button>
      <a-button :style="{ marginLeft: '5px' }" @click="close">关闭</a-button>
      <!-- <a-button @click="onClose" type="primary">Submit</a-button> -->
    </div>
  </a-drawer>
  <!-- </a-modal> -->
</template>

<script>

  import TaskForm from './TaskForm'
  import TaskDeviceDetail from './TaskDeviceDetail'

  export default {
    name: 'DevTaskModal',
    components: {
      TaskForm, TaskDeviceDetail
    },
    props: {
      canEdit: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        title: '',
        width: 1000,
        visible: false,
        disableSubmit: false,
      }
    },
    computed: {
      isHandleAdd () {
        return this.$refs.realForm && this.$refs.realForm.model.id
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk (type) {
        this.$refs.realForm.submitForm(type);
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {

        if (!this.disableSubmit) this.$refs.realForm.clearData()
        this.close()
      },
      handlePrint () {

        let rerpotPrint = document.getElementById('printContent')
        let newContent = rerpotPrint.innerHTML
        let oldContent = document.body.innerHTML
        document.body.innerHTML = newContent
        window.print()
        window.location.reload()
        document.body.innerHTML = oldContent
        return false

      }
    }
  }
</script>
<style lang="less" scoped>
  ::v-deep {
    .ant-modal-footer {
      text-align: center;
    }
  }
</style>